import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { PersonalInfo } from 'src/app/models/interface/CAM/traveler-management';
import { OtpActionType, OtpRequestPayload, } from 'src/app/models/interface/Registration/registration';
import { EmailVerificationComponent } from 'src/app/modules/registration/components/email-verification/email-verification.component';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { LinkAccountDialogComponent } from 'src/app/modules/registration/components/link-account-dialog/link-account-dialog.component';
import { ContentDialogComponent } from 'src/app/shared/components/dialogs/content-dialog/content-dialog.component';
import { environment } from 'src/environments/environment';
import { NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { DateOfbirthComponent } from '../date-ofbirth/date-ofbirth.component';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-personal-info-form',
  templateUrl: './personal-info-form.component.html',
  styleUrls: ['./personal-info-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    NgIf,
    MatIcon,
    MatFormField,
    MatLabel,
    MatSuffix,
    MatSelect,
    NgFor,
    MatOption,
    MatError,
    MatInput,
    DateOfbirthComponent,
    MatRadioGroup,
    MatRadioButton,
    NgSelectComponent,
    AutoBlurSelectDirective,
    NgOptgroupTemplateDirective,
    NgOptionTemplateDirective,
    NgLabelTemplateDirective,
    NgNotFoundTemplateDirective,
    MatCheckbox,
    MatButton,
    MatProgressSpinner,
  ],
})
export class PersonalInfoFormComponent implements OnInit, OnDestroy {
  previewUrl: string | ArrayBuffer | null = null;
  isEmailChanged: boolean | null = null;
  isMobileChanged: boolean | null = null;
  selectedFileName: string | null = null;
  isDisableDateOfBirth = false;
  selectedDOB: Date | null = null;
  editpersonal: boolean = false;
  triptype = '';
  paxTitles: any[] = [];
  userData!: PersonalInfo;
  isElmVerified: boolean = false;
  private readonly elmVerifiedLockedFields = [
    'title',
    'userFirstName',
    'userLastName',
    'userDOB',
    'gender',
  ] as const;
  selectedUserType: string = '';
  dateRanges: Record<string, { minDate: Date; maxDate: Date }> = {};
  dataRange = {
    CHD: { min: 12, max: 2 },
    INS: { min: 2, max: 0 },
    INF: { min: 2, max: 0 },
    ADT: { min: 12, max: 83 },
  };
  TRavellertypecode = '';
  personalinfoForm: FormGroup;
  IsTitleError: boolean = true;
  IsErrorSection: boolean = true;
  IsFirstNameError: boolean = true;
  IsLastNameError: boolean = true;
  IsDOBError: boolean = true;
  IsNationalityError: boolean = true;
  IsPPNOError: boolean = true;
  isFirstTimeError: boolean = true;
  IsPpExpiryError: boolean = true;
  IsIssuingCountryError: boolean = true;
  IsPassengerDocFormInValid: boolean = true;
  onBoardContent: any;
  showUserRights = false;
  userCiamid: string = '';
  @Input() isPassengerInfoPatched: boolean = false;
  @Output() isPassengerInfoPatchedChange = new EventEmitter<boolean>();
  private destroy$ = new Subject<void>();
  userId: string = '';
  guid: string = '';
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false,
  };
  commonObjPipes: any = {
    statename: { pipe: [], all: [] },
    branch: { pipe: [], all: [] },
  };
  hasEmployeeData: boolean = false;
  // loginType: any;
  // loginUserType: any
  loggedInUserType: number = 0;
  isTAEditMode: boolean = true;
  editedUserType: number = 0;
  loginUserGUID: any;
  countriesLists: any[] = [];
  selectedFileImage: any;
  localGuid: any;
  content: any;
  initialFormValue!: any;
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  isProfileMobileNoRestricted: boolean = false;
  SubAgentId: string = '';
  contactId: string = '';
  customerTypes: any;
  titles: any[] = [];
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(
    private readonly crypto: CryptoService,
    private readonly fb: FormBuilder,
    public readonly visibilityService: ComponentVisibilityService,
    private readonly _CamApiService: CamService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _ActivatedRoute: ActivatedRoute,
    private readonly _ToastrApiService: ToastrApiService,
    public readonly _CommonService: CommonService,
    private readonly _ApiService: ApiService,
    private readonly _Router: Router,
    private readonly dialog: MatDialog,
    private readonly contentService: ContentService,
    private readonly signUpContentService: SignUpContentServiceService,
    private readonly ThankyouService: ThankyouService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly travelerManagement: TravelerManagement,
    private readonly _RegistationUtilitiesService: RegistationUtilitiesService,
  ) {
    this.personalinfoForm = this.fb.group({
      title: [
        '',
        [Validators.required, Validators.minLength(2), Validators.maxLength(5)],
      ],
      userFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      userLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      userDOB: ['', [Validators.required]],
      gender: ['Male', Validators.required],
      employeeCode: ['', [Validators.required, Validators.maxLength(25)]],
      emailAddress: ['', [Validators.required, Validators.email]],
      countryCode: [null, Validators.required],
      phoneNumber: ['', [Validators.minLength(8), Validators.maxLength(12)]],
      IsCorpTravelArranger: [0, [Validators.required]],
      isEmpRightsForTrip: false,
      allowUserLiveAccess: false,
      saUserid: '',
      cocnsentTC: [true, [Validators.requiredTrue]],
      consentTCPP: [true, [Validators.requiredTrue]],
      ConsentMarketing: [true, [Validators.requiredTrue]],
      flag: 'UPDATE',
      GUID: [null],
      airlineCode: "Saudia Airlines SV",
      alfursanID: [null, [alfursanValidator]]
    });
  }
  ngOnInit(): void {
    this.SubAgentId = this.crypto.getValueFromKey('SUBAGENTID') as string;
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.signUpContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
        this.getSiteCoreArray('b2b.register.titledropdown')
      });


    this._CamApiService.personalInfoUpdateSuccess$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const changes = this.getChangedFields();
        if (this.guid != this.localGuid) {
          this._Router.navigate(['/cam/traveler-management']);
        }

        if (this.guid == this.localGuid && changes.emailAddress) {
          this.goToLogin();
        }

        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        this.initialFormValue = this.personalinfoForm.getRawValue();
        this.personalinfoForm.markAsPristine();
      });


    this.localGuid = localStorage.getItem('userGuid');
    const stored =
      localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ??
      sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails =
      stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted =
    //   this.companySettingDetails?.restrictAmendmentInTravelerProfile &&
    //   travelerGUID !== userGuid;
    this.isProfileMobileNoRestricted = travelerGUID != userGuid;
    // Control reactive form state
    const phoneControl = this.personalinfoForm.get('phoneNumber');
    const phoneCodeControl = this.personalinfoForm.get('countryCode');

    if (this.isProfileMobileNoRestricted) {
      phoneControl?.disable();
      phoneCodeControl?.disable();
    } else {
      phoneControl?.enable();
      phoneCodeControl?.enable();
    }

    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.countriesLists = this._CommonService.groupCountriesFilter($res);
      })
      .catch(($err) => { });

    this._ActivatedRoute.paramMap.subscribe((params) => {
      const routeUserId = params.get('userId') || '';
      const routeGuid = params.get('guid') || '';
      if (routeUserId && routeGuid) {
        this.userId = routeUserId;
        this.guid = routeGuid;
        sessionStorage.setItem('userId', this.userId);
        sessionStorage.setItem('guid', this.guid);
      } else {
        this.userId = sessionStorage.getItem('userId') || '';
        this.guid = sessionStorage.getItem('guid') || '';
      }

      this.userId = sessionStorage.getItem('userId') || '';
      this.guid = sessionStorage.getItem('guid') || '';
      console.log('Guide = ', this.guid, 'userId = ', this.userId);
      this.syncTAEditMode();
      let payload = {
        subagentId: this.SubAgentId,
        userRole: this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string,
        B2BUserId: this.userId,
      };
      if (this.userId && this.guid) {
        this.editpersonal = true;
        this.Loader.isEditableClicked = true;
        // if (this.isProfileViewRestricted) {
        //   this.personalinfoForm.disable();
        // }
        this._CamApiService
          .PostUserExecutiveV1(this.guid, payload)
          .then((response: any) => {
            if (response?.status === 'Success') {

              this.userData = response.data.personalInfo;
              this.isElmVerified = response?.data?.personalInfo?.isElmVerified || false;
              this.applyElmVerifiedFieldLocks();
              this.contactId = response.data.personalInfo?.contactId;
              this.userCiamid = response.data.personalInfo?.ciamId;
              this.loginUserGUID = response.data.personalInfo?.guid?.toLowerCase().trim()
              this.customerTypes = response.data.personalInfo?.customerTypes;
              const userGuid = localStorage.getItem('userGuid')?.toLowerCase().trim();
              localStorage.setItem('contactID', response.data.personalInfo?.contactId)
              // this.loginType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER',) as string;
              // this.loginUserType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER',) as string;
              this.loggedInUserType = Number(this.crypto.getValueFromKey('ISCORPTRAVELARRANGER'));

              if (
                this.loggedInUserType !== 0 ||
                this.loginUserGUID === userGuid
              ) {
                this.personalinfoForm.get('IsCorpTravelArranger')?.disable();
              } else {
                this.personalinfoForm.get('IsCorpTravelArranger')?.enable();
              }
              this.applyEmployeeCodeLock();



              this._CamApiService.setTravellerciam(this.userData.ciamId);
              console.log('ciam personal info', this.userData.ciamId);
              this.prefillForm(this.userData);
              console.log('UserCiamid personal info', this.userCiamid);
            }
          })
          .catch((error: any) => {
            console.error('Error fetching User executive data:', error);
          });
      } else {
        this.editpersonal = false;
        this.Loader.isEditableClicked = false;
      }
    });


    this.initializeDateRanges();
    this.visibilityService.visibility$
      .pipe(takeUntil(this.destroy$))
      .subscribe((visibility) => {
        this.isChildVisible = visibility;
      });


    // this.personalinfoForm.get('countryCode')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   this.updatePhoneNumberValidators()
    // });

    this.personalinfoForm.get('employeeCode')?.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(() => {
        if (!this.initialFormValue) return;
        this.checkEmployeeCodeDuplicate();
      });

    // this.updatePhoneNumberValidators()
    this.applyEmployeeCodeLock();
  }

  /** Only admin can edit employee code, and never on their own profile. */
  get canEditEmployeeCode(): boolean {
    if (this.loggedInUserType !== 0) {
      return false;
    }
    return !this.isOwnPersonalProfile();
  }

  private isOwnPersonalProfile(): boolean {
    const openedGuid = String(this.guid || this.loginUserGUID || '').toLowerCase().trim();
    const loggedInGuid = String(this.localGuid || localStorage.getItem('userGuid') || '').toLowerCase().trim();
    if (openedGuid && loggedInGuid && openedGuid === loggedInGuid) {
      return true;
    }
    const selectedUserId = String(this.userId || sessionStorage.getItem('userId') || '');
    const loggedInUserId = String(this.crypto.getValueFromKey('USERID') || '');
    return !!selectedUserId && !!loggedInUserId && selectedUserId === loggedInUserId;
  }

  private applyEmployeeCodeLock(): void {
    const empCodeCtrl = this.personalinfoForm.get('employeeCode');
    if (!empCodeCtrl) {
      return;
    }
    if (this.canEditEmployeeCode) {
      empCodeCtrl.enable({ emitEvent: false });
    } else {
      empCodeCtrl.disable({ emitEvent: false });
    }
  }

  /** TA can edit only when opened profile SA_User_ID matches logged-in USERID. */
  private syncTAEditMode(): void {
    this.loggedInUserType = Number(this.crypto.getValueFromKey('ISCORPTRAVELARRANGER'));
    if (this.loggedInUserType === 1) {
      const selectedUserId = String(this.userId || sessionStorage.getItem('userId') || '');
      const loggedInUserId = String(this.crypto.getValueFromKey('USERID') || '');
      this.isTAEditMode = !!loggedInUserId && selectedUserId === loggedInUserId;
    } else {
      this.isTAEditMode = true;
    }
  }

  private applyElmVerifiedFieldLocks(): void {
    if (!this.isElmVerified) {
      this.elmVerifiedLockedFields.forEach((field) => {
        this.personalinfoForm.get(field)?.enable({ emitEvent: false });
      });
      this.isDisableDateOfBirth = false;
      return;
    }

    this.elmVerifiedLockedFields.forEach((field) => {
      this.personalinfoForm.get(field)?.disable({ emitEvent: false });
    });
    this.isDisableDateOfBirth = true;
    this.hideComponent('isDOBCalendarVisible');
  }

  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
  };

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    const isClickInside =
      clickedElement.closest('mat-form-field') ||
      clickedElement.closest('.datepicker-content-container');
    if (!isClickInside) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.personalinfoForm
        .get('userDOB')
        ?.setValidators([Validators.required, this.ageValidator(12)]);
      this.personalinfoForm.get('userDOB')?.updateValueAndValidity();
    }
  }
  private initializeDateRanges(): void {
    this.dateRanges = Object.fromEntries(
      Object.entries(this.dataRange).map(([key, range]) => [
        key,
        {
          minDate: this.calculateDate(range.min),
          maxDate: this.calculateDate(range.max),
        },
      ]),
    );
  }
  private calculateDate(yearsFromNow: number): Date {
    const today = new Date();
    return new Date(
      today.getFullYear() - yearsFromNow,
      today.getMonth(),
      today.getDate(),
    );
  }
  showComponent(componentKey: string, controlName: string): void {
    if (this.isElmVerified) {
      return;
    }
    this.isChildVisible[componentKey] = true;

    if (!!controlName) {
      this.personalinfoForm
        .get(controlName)
        ?.removeValidators([Validators.required]);
      this.personalinfoForm.get(controlName)?.updateValueAndValidity();
    }
  }
  onConfirm(componentKey: string) {
    this.hideComponent(componentKey);
  }
  hideComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = false;
  }
  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      this.selectedDOB = event.date;
      const formattedDate = this.formatDate(this.selectedDOB);
      this.personalinfoForm.get('userDOB')?.setValue(formattedDate);
      this.isChildVisible['isDOBCalendarVisible'] = false;

      //set validation for Traveler age
      const today = new Date();
      const twelveYearsAgo = new Date(
        today.getFullYear() - 12,
        today.getMonth(),
        today.getDate(),
      );
      if (event.date > twelveYearsAgo) {
        this.personalinfoForm.get('userDOB')?.setErrors({ validADT: true });
      } else {
        this.personalinfoForm.get('userDOB')?.setErrors(null);
      }
    }
  }
  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  isDOBInvalid(TRavellertypecode: string): boolean {
    const dobControl = this.personalinfoForm.get('userDOB');
    if (!dobControl) return false;
    const dobValue = dobControl.value;
    if (!dobValue) {
      // dobControl.setErrors({ required: true });
      return false;
    }
    const dobDate =
      dobValue instanceof Date
        ? dobValue
        : new Date(this._CommonService.postFormatDate(dobValue));
    if (isNaN(dobDate.getTime())) {
      dobControl.setErrors({ invalidDate: true });
      return false;
    }
    const range = this.dateRanges[TRavellertypecode];
    if (!range) {
      console.error('Invalid traveler type:', TRavellertypecode);
      return false;
    }
    if (dobDate < range.maxDate || dobDate > range.minDate) {
      dobControl.setErrors({ invalidDOB: true });
      return false;
    }
    dobControl.setErrors(null);
    return true;
  }
  checkEmployeeCodeDuplicate(): void {
    const empCodeCtrl = this.personalinfoForm.get('employeeCode')!;
    const currentValue = (empCodeCtrl.value || '').trim();
    const originalValue = (this.initialFormValue?.employeeCode || '').trim();

    if (currentValue === originalValue) {
      if (empCodeCtrl.hasError('duplicate')) {
        const { duplicate, ...rest } = empCodeCtrl.errors || {};
        empCodeCtrl.setErrors(Object.keys(rest).length ? rest : null);
      }
      return;
    }

    this._CamApiService
      .checkDuplicateEmployeeCode({
        employeeCode: currentValue,
        B2BCompanyId: 'SAA',
        B2BId: this.SubAgentId,
      })
      .then(() => {
        // HTTP 200 → duplicate found
        empCodeCtrl.setErrors({ ...(empCodeCtrl.errors || {}), duplicate: true });
        empCodeCtrl.markAsTouched();
      })
      .catch((error: any) => {
        // HTTP 404 → not found → available
        if (error?.status === 404) {
          if (empCodeCtrl.hasError('duplicate')) {
            const { duplicate, ...rest } = empCodeCtrl.errors || {};
            empCodeCtrl.setErrors(Object.keys(rest).length ? rest : null);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onKeyPress(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const currentValue = target?.value || '';
    const isAlphabetOrSpace = /^[A-Za-z\s]$/.test(event.key);
    if (
      !isAlphabetOrSpace ||
      (event.key === ' ' && currentValue.length === 0)
    ) {
      event.preventDefault();
      return;
    }
  }
  onKeyPressCompCode(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const currentValue = target?.value || '';
    const isValidCharacter = /^[0-9|a-z|A-Z]$/.test(event.key);
    if (!isValidCharacter) {
      event.preventDefault();
    }
  }
  inputPasteValidator(event: ClipboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const pastedData = event.clipboardData?.getData('text') || '';
    const allowedRegex = /^[a-zA-Z() ]*$/;
    const sanitizedData = Array.from(pastedData)
      .filter((char) => allowedRegex.test(char))
      .join('');
    if (sanitizedData !== pastedData) {
      event.preventDefault();
      const currentValue = inputElement.value;
      const cursorPosition = inputElement.selectionStart || 0;
      const updatedValue =
        currentValue.slice(0, cursorPosition) +
        sanitizedData +
        currentValue.slice(cursorPosition);
      inputElement.value = updatedValue;
      inputElement.setSelectionRange(
        cursorPosition + sanitizedData.length,
        cursorPosition + sanitizedData.length,
      );
    }
  }
  onFieldStatusChange(event: {
    isFilled: boolean;
    field: string;
    value: any;
    isValid: boolean;
  }) {
    if (event.field == 'country') {
      this.IsNationalityError = !event.isFilled;
    }
    if (event.field == 'issuingCountry') {
      this.IsIssuingCountryError = !event.isFilled;
    }
    if (event.field == 'PPNo') {
      this.IsPPNOError = !event.isFilled;
    }
    if (event.field == 'PPExpiry') {
      this.IsPpExpiryError = !event.isFilled;
    }
    if (
      this.IsPPNOError ||
      this.IsPpExpiryError ||
      this.IsNationalityError ||
      this.IsIssuingCountryError
    ) {
      this.IsErrorSection = true;
    } else {
      this.IsErrorSection = false;
    }
    this.IsPassengerDocFormInValid =
      this.IsNationalityError ||
      this.IsIssuingCountryError ||
      this.IsPPNOError ||
      this.IsPpExpiryError;
    if (!this.IsPassengerDocFormInValid && this.personalinfoForm.valid) {
      this.isPassengerInfoPatched = true;
      this.isPassengerInfoPatchedChange.emit(this.isPassengerInfoPatched);
    } else {
      this.isPassengerInfoPatched = false;
      this.isPassengerInfoPatchedChange.emit(this.isPassengerInfoPatched);
    }
    if (event.field == 'passanger-doc-form') {
      this.isPassengerInfoPatched = event.isFilled;
      this.isPassengerInfoPatched =
        this.personalinfoForm.valid && this.isPassengerInfoPatched
          ? true
          : false;
      this.isPassengerInfoPatchedChange.emit(event.isFilled);
    }
  }
  Onlyrs(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentInputValue = inputElement.value;
    if (currentInputValue.length >= 64) {
      event.preventDefault();
      return;
    }
    const typedChar = event.key;
    if (typedChar === '.' && currentInputValue.endsWith('.')) {
      event.preventDefault();
    }
  }
  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '$', ' ', ',', '.', '~', '/', '"', "'", '`', '_', '-', '@', '%', '|', '+', ';', '[', ']', ':', '--', '\\', '?', '#', '&', '^', '*', '!', '=', '(', ')', '{', '}',];
    const isAlphabet = /^[a-zA-Z]$/.test(event.key);
    const currentInputLength = (event.target as HTMLInputElement).value.length;

    if (isAlphabet || invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  Editpersonal() {
    if (this.loggedInUserType === 1 && !this.isTAEditMode) {
      return;
    }
    const userRole: any = this.crypto.getValueFromKey(
      'ISCORPTRAVELARRANGER',
    ) as string;

    this.travelerManagement.traveler_detail_click('Edit');
    this.editpersonal = true;
    this.Loader.isEditableClicked = false;
    this.initialFormValue = this.personalinfoForm.getRawValue();
    this.personalinfoForm.markAsPristine();
    this.applyElmVerifiedFieldLocks();
    this.applyEmployeeCodeLock();
    if (userRole != 0) {
      this.personalinfoForm.get('emailAddress')?.disable();
    }
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }

  // ✅ Image selection

  onSave() {
    this.Loader.isSpinner = true
    const changes = this.getChangedFields();
    let initialRawValue: any = JSON.stringify(this.initialFormValue);
    let rowValue: any = JSON.stringify(this.personalinfoForm.getRawValue());
    if (this.personalinfoForm.dirty || changes.userDOB) {

      if (changes.alfursanID && !changes.phoneNumber) {
        this.fetchMatchProfileByAlfursan()
        return
      }

      if (changes.alfursanID && changes.phoneNumber) {
        this.checkMatchWithAlfursanAndMobile()
        return
      }

      rowValue = JSON.parse(rowValue);
      initialRawValue = JSON.parse(initialRawValue);
      delete rowValue.emailAddress;
      delete rowValue.phoneNumber;
      delete initialRawValue.emailAddress;
      delete initialRawValue.phoneNumber;
      if (JSON.stringify(rowValue) !== JSON.stringify(initialRawValue)) {
        if (changes.emailAddress && changes.phoneNumber) {
          this.mobileNumberChange(true);
        } else if (changes.emailAddress && !changes.phoneNumber) {
          this.emailChange(this.personalinfoForm.getRawValue().emailAddress);
        } else if (changes.phoneNumber && !changes.emailAddress) {
          this.mobileNumberChange(false);
        } else if (!changes.emailAddress && !changes.phoneNumber) {
          this.personalInfoChange();
        }
      } else {
        if (changes.emailAddress && changes.phoneNumber) {
          this.mobileNumberChange(true);
        } else if (changes.emailAddress && !changes.phoneNumber) {
          this.emailChange(this.personalinfoForm.getRawValue().emailAddress);
        } else if (changes.phoneNumber && !changes.emailAddress) {
          this.mobileNumberChange(false);
        }
      }
    }
  }

  mobileNumberChange(emailChange: boolean) {
    this.Loader.isSpinner = true;
    const changes = this.getChangedFields()
    if (changes.emailAddress) {
      this.emailChange(this.personalinfoForm.getRawValue().emailAddress);
    } else {
      // this.personalInfoChange();
      this.fetchMatchProfileApi(emailChange)

    }


  }


  triggerMobileOtpFlow(emailChange: boolean) {
    this.Loader.isSpinner = true;
    const payload: OtpRequestPayload = {
      type: 'mobile',
      otpAction: 'mobileOrEmailValidation',
      value: this.personalinfoForm.get('countryCode')?.value + this.personalinfoForm.getRawValue().phoneNumber,
      channel: 'mobile',
      companyId: 'SAA',
      b2BId: null,
      b2BUserId: null,
      eventName: 'PI_MObile_Update',
    };

    this._CamApiService
      .sendOTP(payload)
      .then((res: any) => {
        const checksum = res.data.checksum;
        this.Loader.isSpinner = false;

        let dialog = this.dialog.open(EmailVerificationComponent, {
          data: {
            data: this.personalinfoForm.value,
            PhoneNumber: this.personalinfoForm.get('phoneNumber')?.value,
            countryCode: this.personalinfoForm.get('countryCode')?.value,
            isdCode: this.personalinfoForm.get('countryCode')?.value,
            actionType: OtpActionType.PI_MObile_Update,
            verifyMode: 'sms',
            otpChecksum: checksum,
            travelerPersonalinfo: 'isTravelerPersonalinfo'
          },
        });

        dialog.afterClosed().subscribe((result) => {
          if (result) {
            this.isMobileChanged = true;

            if (emailChange) {
              this.emailChange(
                this.personalinfoForm.getRawValue().emailAddress
              );
            } else {
              this.personalInfoChange();
            }
          }
        });
      })
      .catch((error: any) => {
        this.Loader.isSpinner = false;
        const details = error?.error?.details?.[0];
        if (details?.code === 'DUPLICATE_ENTRY') {
          this._ToastrApiService.show('error', details.title || 'Entry is already present, Please generate token after 30 seconds.');
        } else {
          const msg = error?.error?.message || error?.message || 'Something went wrong';
          this._ToastrApiService.show('error', msg);
        }
      });
  }

  // personalInfoChange() {

  //   this.Loader.isSpinner = true;


  //   const changes = this.getChangedFields();
  //   const accountID = localStorage.getItem('additionalRefNo')
  //   const payload = {
  //     saUserid: this.personalinfoForm.getRawValue().saUserid,
  //     Title: this.personalinfoForm.getRawValue().title,
  //     UserFirstName: this.personalinfoForm.getRawValue().userFirstName,
  //     UserLastName: this.personalinfoForm.getRawValue().userLastName,
  //     UserDOB: this.personalinfoForm.getRawValue().userDOB,
  //     Gender: this.personalinfoForm.getRawValue().gender,
  //     EmployeeCode: this.personalinfoForm.getRawValue().employeeCode,
  //     EmailAddress: this.personalinfoForm.getRawValue().emailAddress,
  //     countryCode: this.personalinfoForm.getRawValue().countryCode,
  //     PhoneNumber: this.personalinfoForm.getRawValue().phoneNumber,
  //     IsCorpTravelArranger:
  //       this.personalinfoForm.getRawValue().IsCorpTravelArranger,
  //     IsProceedToCheckout:
  //       this.personalinfoForm.getRawValue().isEmpRightsForTrip,
  //     BlockUserLiveAccess:
  //       this.personalinfoForm.getRawValue().allowUserLiveAccess,
  //     ConsentTC: this.personalinfoForm.getRawValue().cocnsentTC,
  //     ConsentTCPP: this.personalinfoForm.getRawValue().consentTCPP,
  //     ConsentMarketing: this.personalinfoForm.getRawValue().ConsentMarketing,
  //     Flag: this.personalinfoForm.getRawValue().flag,
  //     Guid: this.personalinfoForm.getRawValue().GUID,
  //     secondaryContactId: this.contactId,
  //     primaryContactId: null,
  //     consentMerge: false,
  //     accountID: accountID,
  //     AlFursanId: this.personalinfoForm.getRawValue().alfursanID,
  //     data: {
  //       isEmailVerified: this.isEmailChanged,
  //       isPhoneVerified: this.isMobileChanged,
  //       ciamId: this.userCiamid,
  //     },
  //   };
  //   this._CamApiService
  //     .UpdatePersonalInformationDetails(payload)
  //     .then(($res) => {
  //       this.isEmailChanged = true;
  //       this.travelerManagement.traveler_detail_click('Save');
  //       if ($res.status == 'Failure') {
  //         this._ToastrApiService.show('error', $res.message);
  //         this.Loader.isSpinner = false;
  //         return;
  //       }
  //       console.log('email changed ', changes.emailAddress);
  //       if (changes.emailAddress) {
  //         this._ToastrApiService.show(
  //           'success',
  //           `Email updated successfully! A verification link will be sent to the employee on the new email.`,
  //         );
  //       } else {
  //         this._ToastrApiService.show(
  //           'success',
  //           `Personal Information ${this.editpersonal ? 'updated' : 'saved'
  //           } successfully.`,
  //         );
  //       }
  //       // console.log('guid ',this.guid);
  //       // console.log('local guid',this.localGuid);
  //       if (this.guid != this.localGuid) {
  //         this._Router.navigate(['/cam/traveler-management']);
  //       }

  //       if (this.guid == this.localGuid && changes.emailAddress) {
  //         this.goToLogin();
  //       }

  //       setTimeout(() => {
  //         this.Loader.isSpinner = false;
  //         this.Loader.isEditableClicked = true;
  //         this.initialFormValue = this.personalinfoForm.getRawValue();
  //         this.personalinfoForm.markAsPristine();
  //       }, 2000);
  //     })
  //     .catch((error) => {
  //       console.error('Error saving data', error);
  //       this.isEmailChanged = true;
  //       this.Loader.isSpinner = false;

  //       let msg = error?.error?.message || error?.message || 'Something went wrong';

  //       if (msg === 'Incorrect OTP') {
  //         msg = 'Invalid OTP';
  //       } else {
  //         try {
  //           const parsedMsg = JSON.parse(error?.error?.message);
  //           msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
  //           if (parsedMsg?.target) {
  //             msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
  //           }
  //         } catch (e) { }
  //       }

  //       this._ToastrApiService.show('error', msg);
  //     });
  // }


  getPartialFormValue() {
    const changes = this.getChangedFields();
    const formValue = this.personalinfoForm.getRawValue();
    const isPhoneDetailsChanged = !!changes.phoneNumber || !!changes.countryCode;

    const isEmailFieldChanged = !!changes.emailAddress;
    this.isEmailChanged = isEmailFieldChanged ? true : null;
    this.isMobileChanged = isPhoneDetailsChanged ? true : null;

    return {
      ...formValue,
      title: changes.title ? formValue.title : null,
      userFirstName: changes.userFirstName ? formValue.userFirstName : null,
      userLastName: changes.userLastName ? formValue.userLastName : null,
      userDOB: changes.userDOB ? formValue.userDOB : null,
      gender: changes.gender ? formValue.gender : null,
      employeeCode: changes.employeeCode ? formValue.employeeCode : null,
      // emailAddress: changes.emailAddress ? formValue.emailAddress : null,
      emailAddress: changes.emailAddress || changes.countryCode || changes.phoneNumber ? formValue.emailAddress : null,
      phoneNumber: isPhoneDetailsChanged ? formValue.phoneNumber : null,
      countryCode: isPhoneDetailsChanged ? formValue.countryCode : null,
      IsCorpTravelArranger: changes.IsCorpTravelArranger ? formValue.IsCorpTravelArranger : null,
      isEmpRightsForTrip: changes.isEmpRightsForTrip ? formValue.isEmpRightsForTrip : null,
      allowUserLiveAccess: changes.allowUserLiveAccess ? formValue.allowUserLiveAccess : null,
      alfursanID: changes.alfursanID ? formValue.alfursanID : null,
    };
  }

  personalInfoChange() {
    this.Loader.isSpinner = true;

    const changes = this.getChangedFields();
    const formValue = this.personalinfoForm.getRawValue();
    const accountID = localStorage.getItem('additionalRefNo');

    const isPhoneDetailsChanged = !!changes.phoneNumber || !!changes.countryCode;
    // const isEmailChanged = !!changes.emailAddress;

    const isEmailFieldChanged = !!changes.emailAddress;
    this.isEmailChanged = isEmailFieldChanged ? true : null;
    this.isMobileChanged = isPhoneDetailsChanged ? true : null;

    // Only changed field value, otherwise null
    const getChangedValue = (fieldName: string) => {
      return changes[fieldName] ? formValue[fieldName] : null;
    };

    const payload = {
      saUserid: this.personalinfoForm.getRawValue().saUserid,

      Title: getChangedValue('title'),
      UserFirstName: getChangedValue('userFirstName'),
      UserLastName: getChangedValue('userLastName'),
      UserDOB: getChangedValue('userDOB'),
      Gender: getChangedValue('gender'),
      EmployeeCode: getChangedValue('employeeCode'),

      EmailAddress: isEmailFieldChanged || isPhoneDetailsChanged ? formValue.emailAddress : null,
      countryCode: isPhoneDetailsChanged ? formValue.countryCode : null,
      PhoneNumber: isPhoneDetailsChanged ? formValue.phoneNumber : null,

      IsCorpTravelArranger: getChangedValue('IsCorpTravelArranger'),

      IsProceedToCheckout: getChangedValue('isEmpRightsForTrip'),
      BlockUserLiveAccess: getChangedValue('allowUserLiveAccess'),

      ConsentTC: this.personalinfoForm.getRawValue().cocnsentTC,
      ConsentTCPP: this.personalinfoForm.getRawValue().consentTCPP,
      ConsentMarketing: this.personalinfoForm.getRawValue().ConsentMarketing,

      Flag: 'UPDATE',
      Guid: this.personalinfoForm.getRawValue().GUID,

      secondaryContactId: this.contactId,
      primaryContactId: null,
      consentMerge: false,
      accountID: accountID,

      AlFursanId: getChangedValue('alfursanID'),

      data: {
        isEmailVerified: isEmailFieldChanged || isPhoneDetailsChanged ? true : null,
        isPhoneVerified: isPhoneDetailsChanged ? true : null,
        ciamId: isEmailFieldChanged || isPhoneDetailsChanged ? this.userCiamid : null,
      },
    };

    console.log('Changed Fields:', changes);
    console.log('Final Update Payload:', payload);

    this._CamApiService
      .UpdatePersonalInformationDetails(payload)
      .then(($res) => {

        this.isEmailChanged = true;

        this.travelerManagement.traveler_detail_click('Save');

        if ($res.status === 'Failure') {
          // AlFursan update failure 
          if (changes.alfursanID) {
            this.travelerManagement.loyalty_update_status('Failure', $res?.error?.message || $res?.message);
          }
        
          // Mobile update failure 
          if (isPhoneDetailsChanged) {
            this.travelerManagement.mobile_update_status('Failure', $res?.error?.message || $res?.message);
          }
          this._ToastrApiService.show('error', $res.message);
          this.Loader.isSpinner = false;
          return;

        }

        // AlFursan update success 
        if (changes.alfursanID) {
          this.travelerManagement.loyalty_update_status('Success', 'NA');
        }
        // Mobile update success 
        if (isPhoneDetailsChanged) {
          this.travelerManagement.mobile_update_status('Success', 'NA');
        }

        if (changes.emailAddress) {
          this._ToastrApiService.show(
            'success',
            'Email updated successfully! A verification link will be sent to the employee on the new email.'
          );
        } else {
          this._ToastrApiService.show(
            'success',
            `Personal Information ${this.editpersonal ? 'updated' : 'saved'} successfully.`
          );
        }

        if (this.guid != this.localGuid) {
          this._Router.navigate(['/cam/traveler-management']);
        }

        if (this.guid == this.localGuid && changes.emailAddress) {
          this.goToLogin();
        }

        setTimeout(() => {
          this.Loader.isSpinner = false;
          this.Loader.isEditableClicked = true;
          this.initialFormValue = this.personalinfoForm.getRawValue();
          this.personalinfoForm.markAsPristine();
        }, 2000);
      })
      .catch((error) => {
        console.error('Error saving data', error);

        this.isEmailChanged = true;
        this.Loader.isSpinner = false;

        let msg =
          error?.error?.message ||
          error?.message ||
          'Something went wrong';

        // AlFursan update failure 
        if (changes.alfursanID) {
          this.travelerManagement.loyalty_update_status('Failure', msg);
        }
        // Mobile update failure 
        if (isPhoneDetailsChanged) {
          this.travelerManagement.mobile_update_status('Failure', msg);
        }

        if (msg === 'Incorrect OTP') {
          msg = 'Invalid OTP';
        } else {
          try {
            const parsedMsg = JSON.parse(error?.error?.message);

            msg =
              parsedMsg?.details?.[0]?.message?.message ||
              parsedMsg?.details?.[0]?.message?.Message ||
              msg;

            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }
        }

        this._ToastrApiService.show('error', msg);
      });
  }



  emailChange(email: string) {
    const userid = this.userCiamid;
    let payload = {
      email: email,
    };
    this._CamApiService.updateEmail(payload, userid).subscribe({
      next: ($res: any) => {
        if ($res.status === 'Failure') {
          this._ToastrApiService.show('error', $res.message);
          this.travelerManagement.email_update_status('Failure', $res.message);
          this.Loader.isSpinner = false;
          return;
        }

        this.isEmailChanged = false;
        this.travelerManagement.email_update_status('Success', 'NA');
        this.personalInfoChange();
      },
      error: (error) => {
        console.error('Error saving data', error);
      },
    });
  }
  goToLogin() {
    setTimeout(() => {
      this.Loader.isSpinner = false;
      this.Loader.isEditableClicked = true;

      this.ThankyouService.show({
        heading: "You've been logged out!",
        // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
        buttonText: 'Go To Login',
        isShowButton: true,
        redirectUrl: '',
      });
    });
  }
  getChangedFields() {
    const changes: any = {};
    const current = this.personalinfoForm.getRawValue();
    Object.keys(current).forEach((key) => {
      if (current[key] !== this.initialFormValue[key]) {
        changes[key] = {
          old: this.initialFormValue[key],
          new: current[key],
        };
      }
    });

    return changes;
  }

  /** True when the form value actually differs from initial. Used to enable Save button. */
  get hasFormChanges(): boolean {
    if (!this.initialFormValue) return false;
    return Object.keys(this.getChangedFields()).length > 0;
  }

  Cancel() {
    this.travelerManagement.traveler_detail_click('Cancel');
    if (this.hasEmployeeData) {
      this.Loader.isEditableClicked = true;
      this.Loader.isSpinner = false;
      this.prefillForm(this.userData);
    } else {
      this.Loader.isEditableClicked = false;
      this.Loader.isSpinner = false;

      this.personalinfoForm.reset({
        gender: 'Male',
        IsCorpTravelArranger: 0,
      });
    }
  }

  prefillForm(userData: PersonalInfo): void {
    // this.loginType = userData.isCorporateTravelArranger;
    this.editedUserType = Number(userData.isCorporateTravelArranger);

    if (userData) {
      this.personalinfoForm.patchValue({
        title: userData.title,
        userFirstName: userData.firstName,
        userLastName: userData.lastName,
        userDOB: this.formatDate(new Date(userData.userDOB)),
        gender: userData.gender,
        employeeCode: this.userData.employeeCode,
        emailAddress: userData.email,
        countryCode: userData.phoneExtension,
        phoneNumber: userData.phoneNumber,
        IsCorpTravelArranger: +userData.isCorporateTravelArranger,
        altTravelerCode: userData.altTravelerCode,
        isEmpRightsForTrip: userData.hasEmployeeRightsForTrip,
        allowUserLiveAccess: userData.allowLiveAccess,
        Access_Personal_Data: userData.accessPersonalData,
        Ok_With_Offers_MarketingInfo: userData.okWithMarketingInfo,
        saUserid: userData.saUserId,
        GUID: userData.guid,
        SubagentImage: userData.imagePath,
        alfursanID: userData.alFursanId
      });
      this.hasEmployeeData = this._CommonService.hasAnyValue(
        this.personalinfoForm.value,
      ); // value is in form or not
      this.personalinfoForm.markAllAsTouched();
      this.applyElmVerifiedFieldLocks();
      this.applyEmployeeCodeLock();
      if (this.hasEmployeeData) {
        this.Loader.isEditableClicked = true;
        // this.personalinfoForm.get('emailAddress')?.disable();
        // this.personalinfoForm.get('loginName')?.disable();
      } else {
        this.Loader.isEditableClicked = false;
        // this.personalinfoForm.get('emailAddress')?.enable();
        // this.personalinfoForm.get('loginName')?.enable();
      }
      if (this.userData.employeeBookingRights == 0) {
        this.personalinfoForm.get('InstantBooking')?.setValue(true);
      } else if (this.userData.employeeBookingRights == 1) {
        this.personalinfoForm.get('InstantBooking')?.setValue(true);
        this.personalinfoForm.get('inPolicyBooking')?.setValue(true);
        this.personalinfoForm.get('outPolicyBooking')?.setValue(true);
      } else if (this.userData.employeeBookingRights == 2) {
        this.personalinfoForm.get('InstantBooking')?.setValue(true);
        this.personalinfoForm.get('inPolicyBooking')?.setValue(true);
      } else if (this.userData.employeeBookingRights == 3) {
        this.personalinfoForm.get('InstantBooking')?.setValue(true);
        this.personalinfoForm.get('outPolicyBooking')?.setValue(true);
      }
      this.personalinfoForm.get('flag')?.setValue('UPDATE');
      this.personalinfoForm.get('branch')?.setValue(userData.corpBranchId);
      this.personalinfoForm.get('saUserid')?.setValue(userData.saUserId);
      this.cdr.detectChanges();
      // this.personalinfoForm.get("loginName")?.disable();
      // this.personalinfoForm.get("emailAddress")?.disable();
      this.initialFormValue = this.personalinfoForm.getRawValue();
    } else {
      console.error('No user data provided to prefill the form.');
    }

    if (userData.alFursanId) {
      this.personalinfoForm.get('alfursanID')?.disable();
    }
  }

  // Custom age validator function
  private ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (!value) {
        return null; // Let required validator handle empty case
      }

      try {
        // Parse DD/MM/YYYY format
        const dateParts = value.split('/');
        if (dateParts.length !== 3) {
          return null; // Invalid format, let other validators handle
        }

        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Months are 0-indexed
        const year = parseInt(dateParts[2], 10);

        const birthDate = new Date(year, month, day);

        // Check if date is valid
        if (isNaN(birthDate.getTime())) {
          return null; // Invalid date
        }

        const today = new Date();
        const twelveYearsAgo = new Date(
          today.getFullYear() - minAge,
          today.getMonth(),
          today.getDate(),
        );

        return birthDate <= twelveYearsAgo ? null : { validADT: true };
      } catch (error) {
        return null; // Invalid date format
      }
    };
  }
  convertText(text: string) {
    let value = { p1: '', p2: '' };
    if (text) {
      let replcacedText = text?.split('</p>\n\n<p>');
      value.p1 = replcacedText[0]?.replace('<p>', '');
      value.p2 = replcacedText[1]?.replace('</p>', '');
    }
    return value;
  }

  getSiteCoreArray(keyString: string) {
    const data = this.onBoardContent?.[keyString];
    this.titles = data;
    //  data?.map((item: any) => ({
    //    ...item,
    //    Phrase: item.Phrase?.replace(/\./g, '') // dot ho ya na ho → safe
    //  })) || [];
  }



  async checkEmailExist(): Promise<void> {

    const emailControl = this.personalinfoForm.get('emailAddress');
    const email = emailControl?.value;
    const companyID = 'SAA';

    if (!email || email === this.initialFormValue?.emailAddress) return;


    const payload = { loginID: email };

    try {
      const [verifyRes, matchingRes] = await Promise.all([
        this._CamApiService.checkEmailExist(companyID, email), // API 1
        this._CamApiService.isAvailableLogin(payload), // API 2
      ]);

      // 🔹 RESULT 1 → Verify User Exists API
      const userExists = verifyRes?.data === true; // adjust if API structure differs

      // 🔹 RESULT 2 → Matching Profile API
      const hasMatch = !matchingRes?.data?.isAvailable;

      // 🚨 If ANY API says email exists → show error
      if (hasMatch || userExists) {
        emailControl.setErrors({ ...emailControl.errors, isExist: true });
      } else {
        if (emailControl.hasError('isExist')) {
          const errors = { ...emailControl.errors };
          delete errors['isExist'];
          emailControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    } catch (error: any) {
      console.error('Email verification APIs failed:', error);
      const hasReg019Error = error?.error?.details?.some?.(
        (detail: any) => detail?.code === 'REG-019',
      );
      if (hasReg019Error) {
        const currentErrors = { ...(emailControl.errors || {}) };
        emailControl.setErrors({ ...currentErrors, isExist: true });
      }
    }
  }

  checkMobileNumberExist() {
    const phoneNumberControl = this.personalinfoForm.get('phoneNumber');
    const companyID = 'SAA';

    let phoneNumber = phoneNumberControl?.value;

    if (!phoneNumber) return;

    // 🧠 Clean number (remove spaces)
    phoneNumber = phoneNumber.replace(/\s+/g, '');

    // 🚫 Skip if unchanged
    if (phoneNumber === this.initialFormValue?.phoneNumber) return;

    const payload = {
      phoneNumber: phoneNumber,
      contactId: this.contactId,
      B2BId: this.crypto.getValueFromKey('SUBAGENTID') as string,
    };

    this._CamApiService
      .checkPhoneNumberExist(companyID, payload)
      .then((res: any) => {
        if (res?.data === true) {
          // ❌ Number already exists
          phoneNumberControl?.setErrors({
            ...phoneNumberControl.errors,
            mobileExist: true
          });
        } else {
          // ✅ Remove only mobileExist error
          if (phoneNumberControl?.hasError('mobileExist')) {
            const { mobileExist, ...rest } = phoneNumberControl.errors || {};
            phoneNumberControl.setErrors(
              Object.keys(rest).length ? rest : null
            );
          }
        }
      })
      .catch((error: any) => {
        console.error('Phone check failed', error);
      });
  }


  fetchMatchProfileApi(emailChange: boolean) {

    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const mobile = this.personalinfoForm.get('phoneNumber')?.value;
    const code = this.personalinfoForm.get('countryCode')?.value;
    const firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    const lastName = this.crypto.getValueFromKey("USERLNAME") as string;


    const matchPayload = {
      mobile: `${code}${mobile}`,
      // mobile: '+911234567890',

      matchPreferences: {
        isProfileUpdate: true,
        sourceProfile: `[${this.customerTypes.join(', ')}]`,
        contactId: this.contactId
      }
    };

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, matchPayload)
      .subscribe({
        next: (res: any) => {
          this.Loader.isSpinner = false;
          const matchType = res?.data?.identifiers?.matchType;
          const mobileClaimAllowed = res?.data?.identifiers?.mobileClaimAllowed;
          const matchedContacts = res?.data?.matchedContacts || [];

          if (matchType === 'mobile' && matchedContacts.length === 0 && !mobileClaimAllowed) {
            this.dialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description: 'Another account already exists with the phone number, You can register with a different phone number.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                travelerPersonalinfo: 'isTravelerPersonalinfo'
              }
            });
            return;
          }

          const hasMatch =
            Array.isArray(matchedContacts) &&
            matchedContacts.length > 0;


          if (hasMatch) {
            this.dialog.open(LinkAccountDialogComponent, {
              disableClose: true,
              data: {
                matches: res.data,
                fullName: `${firstName} ${lastName}`,
                data: this.getPartialFormValue(),
                method: 'personalInfoMobMatch',
                ciamID: this.userCiamid,
                secondaryContactID: this.contactId,
                loginCustomerTypd: this.customerTypes,
                travelerPersonalinfo: 'isTravelerPersonalinfo'
              },
            });
          } else {
            // ✅ 👉 YAHAN DIRECT OTP FLOW
            this.triggerMobileOtpFlow(emailChange)
          }
        },
        error: (err: any) => {
          this.Loader.isSpinner = false;
          console.error(err);
        }
      });
  }


  fetchMatchProfileByAlfursan() {
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const alfursanId = this.personalinfoForm.get('alfursanID')?.value;
    const mobile = this.personalinfoForm.get('phoneNumber')?.value;
    const code = this.personalinfoForm.get('countryCode')?.value;
    const firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    const lastName = this.crypto.getValueFromKey("USERLNAME") as string;

    const matchPayload = {
      fursanId: alfursanId, // ✅ yahi change hai
      matchPreferences: {
        isProfileUpdate: true,
        sourceProfile: `[${this.customerTypes.join(', ')}]`,
        contactId: this.contactId
      }
    };

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, matchPayload)
      .subscribe({
        next: (res: any) => {
          this.Loader.isSpinner = false;

          const hasMatch =
            Array.isArray(res?.data?.matchedContacts) &&
            res?.data?.matchedContacts.length > 0;

          if (!hasMatch) {
            this.personalinfoForm.get('alfursanID')?.setErrors({ invalidAlfursan: true });
          } else {
            this.checkMatchWithAlfursanAndMobile()

          }
        },
        error: (err: any) => {
          this.Loader.isSpinner = false;
          console.error(err);
        }
      });
  }

  checkMatchWithAlfursanAndMobile() {
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const alfursanId = this.personalinfoForm.get('alfursanID')?.value;
    const mobile = this.personalinfoForm.get('phoneNumber')?.value;
    const code = this.personalinfoForm.get('countryCode')?.value;
    const firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    const lastName = this.crypto.getValueFromKey("USERLNAME") as string;


    const matchPayload = {
      fursanId: alfursanId,
      mobile: `${code}${mobile}`,
      matchPreferences: {
        isProfileUpdate: true,
        sourceProfile: `[${this.customerTypes.join(', ')}]`,
        contactId: this.contactId
      }
    };

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, matchPayload)
      .subscribe({
        next: (res: any) => {
          this.Loader.isSpinner = false;

          const matchType = res?.data?.identifiers?.matchType;
          const mobileClaimAllowed = res?.data?.identifiers?.mobileClaimAllowed;
          const matchedContacts = res?.data?.matchedContacts || [];

          if (matchType === 'mobile' && matchedContacts.length === 0 && !mobileClaimAllowed) {
            this.dialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description: 'Another account already exists with the phone number, You can register with a different phone number.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                travelerPersonalinfo: 'isTravelerPersonalinfo'
              }
            });
            return;
          }

          const hasMatch =
            Array.isArray(matchedContacts) &&
            matchedContacts.length > 0;

          if (hasMatch) {

            // getPartialFormValue() -> only changed fields // But AlFursan match ke case me mobile details bhi bhejni hain 
            const partialData = this.getPartialFormValue();
            const data = {
              ...partialData,
            };

            this.dialog.open(LinkAccountDialogComponent, {
              disableClose: true,
              data: {
                matches: res.data,
                fullName: `${firstName} ${lastName}`,
                data: data,
                method: 'personalInfoMobMatch',
                ciamID: this.userCiamid,
                secondaryContactID: this.contactId,
                loginCustomerTypd: this.customerTypes,
                travelerPersonalinfo: 'isTravelerPersonalinfo'
              },
            });
          } else {
            this.personalInfoChange();
          }
        },
        error: (err: any) => {
          this.Loader.isSpinner = false;
          console.error(err);
        }
      });
  }


  updatePhoneNumberValidators() {
    const phoneControl = this.personalinfoForm.get('phoneNumber');
    const selectedCountry = this.personalinfoForm.get('countryCode')?.value;
    const countryCode = selectedCountry;

    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }

}


export function alfursanValidator(control: AbstractControl): ValidationErrors | null {
  console.log(control)
  const value = control.value;

  if (!value) return null;

  const isNumber = /^\d+$/.test(value);
  const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);

  if (isNumber) {
    return value.length === 10 ? null : { invalidNumberLength: true };
  }

  if (isEmail) {
    return value.length <= 200 ? null : { emailMaxLength: true };
  }

  return { pattern: true };
}
